import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/Api/axiosV2Config';
import type { ContractFilters, ContractListResponse, ContractDraft } from '@/features/contracts/types/contract.types';

/**
 * Hook React Query pour récupérer la liste des contrats
 * Utilisé dans le sélecteur de contrat du formulaire delivery proof
 */
export const useContracts = (filters?: ContractFilters) => {
  return useQuery({
    queryKey: ['contracts', filters],
    queryFn: async () => {
      const { data } = await axiosInstance.get<ContractListResponse>('/pro-v2/contracts', {
        params: filters,
      });
      return data;
    },
    staleTime: 30000,
  });
};

/**
 * Hook React Query pour récupérer les brouillons de contrat
 */
export const useContractDrafts = () => {
  return useQuery({
    queryKey: ['contract-drafts'],
    queryFn: async () => {
      const { data } = await axiosInstance.get<ContractDraft[]>('/pro-v2/contracts/drafts');
      return data;
    },
    staleTime: 30000,
  });
};
